import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { IItemRenderer } from '../../interfaces/item-renderer.table';

@Component({
  selector: 'opt-text-item-renderer',
  templateUrl: './text-item-renderer.component.html',
  styleUrls: ['./text-item-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextItemRendererComponent implements OnInit, IItemRenderer {
  @Input() id: string;
  @Input() value: any;

  constructor() {}

  ngOnInit(): void {}
}
